import { hasError } from '../../../../../../../utils';
import Button from '../../../../../../generic/Button/Button';
import ButtonGroup from '../../../../../../generic/Button/ButtonGroup';
import { ErrorAlert } from '../../../../../../generic/ErrorAlert';
import LabeledTextInput from '../../../../../../generic/Forms/LabeledTextInput';
import { icons } from '../../../../../../generic/Icon/icons';
import { Icon } from '../../../../../../generic/Icon/index';
import type { OrganizationsStore } from '../../../../../../../redux/organizations';

type EnterEmailStepBodyProps = {
  domain: string;
  emailUser: string;
  setEmailUser: (emailUser: string) => void;
  ssoConfigurationStatus: OrganizationsStore['ssoConfigurationStatus'];
};

export const EnterEmailStepBody = ({
  domain,
  emailUser,
  setEmailUser,
  ssoConfigurationStatus,
}: EnterEmailStepBodyProps) => (
  <>
    <p className="margin-bottom-md">
      Enter an email address that is under the domain that you’re claiming to be sent a verification email.
    </p>
    {hasError(ssoConfigurationStatus) && <ErrorAlert status={ssoConfigurationStatus} />}
    <LabeledTextInput labelVariant="legacy" label="Email address" value={emailUser} onChange={setEmailUser} suffix={`@${(domain)}`} />
    {emailUser.includes('@') && <div className="input-error-message">Email address is invalid</div>}
  </>
);

type EnterEmailStepButtonsProps = {
  emailUser: string;
  ssoConfigurationStatus: OrganizationsStore['ssoConfigurationStatus'];
  onCancel: () => void;
  onNextStep: () => void;
};

export const EnterEmailStepButtons = ({
  emailUser,
  onCancel,
  onNextStep,
  ssoConfigurationStatus,
}: EnterEmailStepButtonsProps) => (
  <ButtonGroup>
    <Button type="secondary" onClick={onCancel}>
      Back
    </Button>
    <Button
      onClick={onNextStep}
      isDisabled={!emailUser.trim() || emailUser.includes('@') || ssoConfigurationStatus.loading}
    >
      {ssoConfigurationStatus.loading && (
        <span className="margin-right-xs">
          <Icon icon={icons.circleO} hasSpin />
        </span>
      )}
      Continue
    </Button>
  </ButtonGroup>
);
